// PublicationEventsTimeline · Lot M4
// Timeline verticale des events publications.

import { Megaphone, Plus, Play, Pause, Pencil, User } from "lucide-react";

const TYPE_META = {
  channel_added:       { label: "Canal ajouté",     Icon: Plus,   tone: "bg-black text-white" },
  channel_activated:   { label: "Canal activé",     Icon: Play,   tone: "bg-emerald-500 text-white" },
  channel_deactivated: { label: "Canal désactivé",  Icon: Pause,  tone: "bg-slate-500 text-white" },
  listing_updated:     { label: "Annonce mise à jour", Icon: Pencil, tone: "bg-sky-500 text-white" },
};

const fmt = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return ""; }
};

export default function PublicationEventsTimeline({ events = [], loading = false }) {
  if (loading) {
    return (
      <div className="space-y-3" data-testid="publication-events-loading">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-14 animate-pulse rounded-2xl bg-black/[0.03]" />
        ))}
      </div>
    );
  }
  if (!events.length) {
    return (
      <div className="rounded-2xl bg-black/[0.02] px-4 py-6 text-center text-[12.5px] text-black/45"
           data-testid="publication-events-empty">
        Aucun événement de publication pour l&apos;instant.
      </div>
    );
  }

  return (
    <ol className="space-y-0 relative" data-testid="publication-events-timeline">
      <div className="absolute left-[7px] top-2 bottom-2 w-px bg-black/[0.08]" />
      {events.map((e, idx) => {
        const meta = TYPE_META[e.type] || TYPE_META.channel_added;
        const Icon = meta.Icon;
        return (
          <li key={e.id || idx}
              className="relative pl-8 pb-6 last:pb-0"
              data-testid={`publication-event-${idx}`}>
            <span className={`absolute left-[-2px] top-[5px] h-[19px] w-[19px] rounded-full border-[3px] border-[#FAFAF7] ${meta.tone.split(" ")[0]} flex items-center justify-center`}>
              <Icon size={9} className="text-white" strokeWidth={2.3} />
            </span>
            <div className="text-[13.5px] font-medium text-black">
              {meta.label}
            </div>
            <div className="mt-1 flex flex-wrap items-center gap-x-2 text-[12.5px] text-black/60">
              <span className="font-mono">{e.channel}</span>
              {e.to?.external_url && e.type === "listing_updated" && (
                <span className="truncate text-black/40">
                  → {e.to.external_url}
                </span>
              )}
            </div>
            <div className="mt-1.5 flex items-center gap-1.5 text-[11px] text-black/40">
              <User size={11} strokeWidth={1.7} />
              <span>{e.actor_name || "—"}</span>
              <span>·</span>
              <time>{fmt(e.at)}</time>
              {e.source === "connector" && (
                <span className="ml-1 rounded-full bg-sky-50 px-1.5 py-0.5 text-[9.5px] text-sky-700 uppercase tracking-[0.12em]">
                  connector
                </span>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
